<div class="ui-g">
  <div class="ui-g-12">
    <p-fieldset [style]="{ border: '1px solid #000000' }">
      <p-header><b>Login Credentials</b></p-header>
      <div class="ui-g">
        <div class="ui-lg-6 ui-g-12">
          <form #emailEditForm="ngForm" autocomplete="off" (ngSubmit)="submitEditEmail()" accept-charset="UTF-8">
            <ng-container *ngIf="!this.editData.emailData.isEdit; else editEmailView">
              <label class="ui-g-12" for="user_id" *ngIf="this.posting">
                {{ this.editData.emailData.data.getLabel() }}
              </label>
              <p *ngIf="this.posting">{{ this.displayEmailPhone(this.editData.emailData.value) }}</p>
              <p class="alert alert-danger" *ngIf="!this.editData.emailData.has_verified">
                Email is not verified.
              </p>
              <button pButton type="button" label="Edit" style="margin-bottom: 10px; margin-right: 5px"
                class="ui-button-info ui-button-rounded" (click)="editEmail()" [disabled]="isPosting()"></button>
            </ng-container>
            <ng-template #editEmailView>
              <ng-container *ngIf="this.editData.emailData.tabViewData.selected_tab == 0">
                <userid-input class="col-12" [userid_data]="this.editData.emailData.data" [isPrimeNg]="true">
                </userid-input>
                <div class="ui-g-12">
                  <button pButton type="submit" label="Send OTP" style="margin-bottom: 10px; margin-right: 5px"
                    class="ui-button-success ui-button-rounded" [disabled]="
                      !emailEditForm.valid ||
                      isPosting() ||
                      !this.editData.emailData.data.continueButtonCondition()
                    "></button>
                  <button pButton type="button" label="Cancel" style="margin-right: 10px"
                    class="ui-button-warning ui-button-rounded" (click)="cancelEditEmail()"
                    [disabled]="isPosting()"></button>
                </div>
              </ng-container>
              <ng-container *ngIf="this.editData.emailData.tabViewData.selected_tab == 1">
                <div class="ui-g">
                  <div class="form-heading-section mt-4 ui-g-12">
                    <p class="form-sub-heading">We have sent an OTP on</p>
                    <h2>
                      {{
                      this.editData.emailData.data.getCompleteUserIdValue()
                      }}
                    </h2>
                  </div>
                  <div class="form-div ui-g-12">
                    <form #otpEmailForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8"
                      id="register_form">
                      <div class="form-group ui-g">
                        <otp-input class="ui-g-12" [isPrimeNg]="true" [otp_data]="this.editData.emailData.otp_data"
                          (otp_resend)="otp_resend()">
                        </otp-input>
                      </div>
                      <div class="form-group ui-g-12">
                        <button pButton type="submit" label="Verify" style="margin-left: 10%"
                          class="ui-button-success ui-button-rounded"
                          [disabled]="isPosting() || !otpEmailForm.valid"></button>
                      </div>
                    </form>
                  </div>
                </div>
              </ng-container>
            </ng-template>
            <div class="ui-g-12">
              <app-error-messages [api_result]="this.editData.emailData.edit_api_result">
              </app-error-messages>
              <app-error-messages [api_result]="this.editData.emailData.otp_data.otp_api_result">
              </app-error-messages>
            </div>
          </form>
        </div>
        <div class="ui-lg-6 ui-g-12">
          <form #phoneNoEditForm="ngForm" autocomplete="off" (ngSubmit)="submitEditMobile()" accept-charset="UTF-8">
            <ng-container *ngIf="!this.editData.mobileData.isEdit; else editMobileView">
              <label class="ui-g-12" for="user_id" *ngIf="this.posting">
                {{ this.editData.mobileData.data.getLabel() }}
              </label>
              <p *ngIf="this.posting">
                {{ this.displayEmailPhone(this.editData.mobileData.value) }}
              </p>
              <p class="alert alert-danger" *ngIf="!this.editData.mobileData.has_verified">
                Mobile Number is not verified.
              </p>
              <button pButton type="button" label="Edit" style="margin-bottom: 10px; margin-right: 5px"
                class="ui-button-info ui-button-rounded" (click)="this.editMobile()" [disabled]="isPosting()"></button>
            </ng-container>
            <ng-template #editMobileView>
              <ng-container *ngIf="this.editData.mobileData.tabViewData.selected_tab == 0">
                <userid-input class="col-12" [userid_data]="this.editData.mobileData.data" [isPrimeNg]="true">
                </userid-input>
                <div class="ui-g-12">
                  <button pButton type="submit" label="Send OTP" style="margin-right: 10px"
                    class="ui-button-success ui-button-rounded" [disabled]="
                      !phoneNoEditForm.valid ||
                      isPosting() ||
                      !this.editData.mobileData.data.continueButtonCondition()
                    "></button>
                  <button pButton type="button" label="Cancel" style="margin-right: 10px"
                    class="ui-button-warning ui-button-rounded" (click)="cancelEditMobile()"
                    [disabled]="isPosting()"></button>
                </div>
              </ng-container>
              <ng-container *ngIf="this.editData.mobileData.tabViewData.selected_tab == 1">
                <div class="ui-g">
                  <div class="form-heading-section mt-4 ui-g-12">
                    <p class="form-sub-heading">We have sent an OTP on</p>
                    <h2>{{ this.editData.mobileData.data.contact_number }}</h2>
                  </div>
                  <div class="form-div ui-g-12">
                    <form #otpMobileForm="ngForm" (ngSubmit)="otpVerifySubmit()" accept-charset="UTF-8"
                      id="register_form">
                      <div class="form-group ui-g">
                        <otp-input class="ui-g-12" [isPrimeNg]="true" [otp_data]="this.editData.mobileData.otp_data"
                          (otp_resend)="otp_resend()">
                        </otp-input>
                      </div>

                      <div class="form-group ui-g-12">
                        <button pButton type="submit" label="Verify" style="margin-left: 10%"
                          class="ui-button-success ui-button-rounded"
                          [disabled]="isPosting() || !otpMobileForm.valid"></button>
                      </div>
                    </form>
                  </div>
                </div>
              </ng-container>
            </ng-template>

            <div class="ui-g-12">
              <app-error-messages [api_result]="this.editData.mobileData.edit_api_result">
              </app-error-messages>
              <app-error-messages [api_result]="this.editData.mobileData.otp_data.otp_api_result">
              </app-error-messages>
            </div>
          </form>
        </div>
        <div class="ui-lg-6 ui-g-12">
          <form #passwordEditForm="ngForm" autocomplete="off" (ngSubmit)="submitEditPassword()" accept-charset="UTF-8">
            <p-checkbox [(ngModel)]="
                this.editData.password_edit.password_edit_api.password_change
              " [value]="editData.password_edit.password_edit_api.password_change" (onChange)="resetEditPassswordApi()"
              [binary]="true" #passwordchange="ngModel" name="passwordchange" [required]="true"></p-checkbox>
            Change Password
            <div *ngIf="
                this.editData.password_edit.password_edit_api.password_change
              ">
              <!-- <div class="ui-g-12">
                                <div class="ui-g-12 ui-md-4">
                                    <label for="previouspassword">Previous Password<span class="req">*</span></label>
                                </div>
                                <div class="ui-g-12 ui-md-8">
                                    <input pInputText placeholder="Previous Password"
                                        style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                        maxlength="25"
                                        [type]="this.editData.password_edit.current_password.isPassword?'password':'text'"
                                        name="previouspassword"
                                        [(ngModel)]="this.editData.password_edit.password_edit_api.prev_password"
                                        #prevpassword="ngModel"
                                        [required]="this.editData.password_edit.password_edit_api.password_change">


                                </div>
                            </div> -->
              <div class="ui-g-12">
                <div class="ui-g-12 ui-md-4">
                  <label for="password1">Password<span class="req">*</span></label>
                </div>
                <div class="ui-g-12 ui-md-8">
                  <input placeholder="Password" pInputText style="
                      width: 260px;
                      border-color: rgb(16, 151, 16);
                      color: black;
                      opacity: inherit;
                    " [type]="
                      this.editData.password_edit.new_password.isPassword
                        ? 'password'
                        : 'text'
                    " FieldValidator="password" [(ngModel)]="
                      this.editData.password_edit.password_edit_api.e_password
                    " name="password1" #password1="ngModel" maxlength="25" [required]="
                      this.editData.password_edit.password_edit_api
                        .password_change
                    " />
                  <span toggle="#password-field" [ngClass]="{
                      'fa fa-fw fa-eye':
                        !this.editData.password_edit.new_password.isPassword,
                      'pi pi-eye-slash':
                        this.editData.password_edit.new_password.isPassword
                    }" style="color: black; margin: auto; padding-left: 5px" (click)="
                      this.editData.password_edit.current_password.toggleType();
                      this.editData.password_edit.new_password.toggleType();
                      this.editData.password_edit.confirm_password.toggleType()
                    "></span>

                  <!-- <span toggle="#password-field" class="fa fa-fw fa-eye field_icon " (click)="changeType()" ></span> -->
                </div>
              </div>
              <div class="ui-g-12">
                <div class="ui-g-12 ui-md-4">
                  <label for="confirmpassword">Confirm Password<span class="req">*</span></label>
                </div>
                <div class="ui-g-12 ui-md-6">
                  <input pInputText placeholder="Confirm Password" style="
                      width: 260px;
                      border-color: rgb(16, 151, 16);
                      color: black;
                      opacity: inherit;
                    " maxlength="25" [type]="
                      this.editData.password_edit.confirm_password.isPassword
                        ? 'password'
                        : 'text'
                    " name="confirmpassword" [(ngModel)]="
                      this.editData.password_edit.password_edit_api
                        .confirm_password
                    " #confirmpassword="ngModel" [required]="
                      this.editData.password_edit.password_edit_api
                        .password_change
                    " />
                </div>
                <div class="ui-md-1"></div>
                <div class="ui-md-1">
                  <div>
                    <div>
                      <a style="display: inline-block" (click)="
                          this.editData.password_edit.confirm_password.toggleTips()
                        ">
                        <i class class="fa fa-fw fa-question-circle"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div *ngIf="
                    password1.invalid && (password1.dirty || password1.touched)
                  " class="alert alert-danger1">
                  <div *ngIf="password1.errors.required" class="invalid">
                    Password is required.
                  </div>
                  <div *ngIf="password1.errors.FieldValidator" class="invalid">
                    Password should contain minimum 8 characters, at least 1
                    Uppercase, 1 Lowercase , 1 Special Character and 1 number.
                  </div>
                </div>
              </div>
              <div *ngIf="password1.value != confirmpassword.value" class="alert alert-danger1">
                <div class="invalid">
                  Password and Confirm Password do not match.
                </div>
              </div>

              <div *ngIf="
                  confirmpassword.invalid &&
                  (confirmpassword.dirty || confirmpassword.touched)
                ">
                <div *ngIf="confirmpassword.errors.required" class="invalid">
                  Confirm password is required.
                </div>
              </div>
              <div class="justify-content-center text-center" id="div_content357" *ngIf="
                  this.editData.password_edit.confirm_password
                    .tipsPasswordShowed
                ">
                <div class="alert alert-danger1">
                  Password should contain minimum 8 characters, at least 1
                  Uppercase, 1 Special Character and 1 number.
                </div>
              </div>
              <div class="form-group ui-g-12">
                <button pButton type="submit" label="Save" style="margin-left: 10%"
                  class="ui-button-success ui-button-rounded" [disabled]="
                    this.editData.password_edit.password_edit_api.e_password !=
                      this.editData.password_edit.password_edit_api
                        .confirm_password ||
                    isPosting() ||
                    !passwordEditForm.valid
                  "></button>
              </div>
              <div class="ui-g-12 text-center">
                <app-error-messages [api_result]="this.editData.password_edit.api_result">
                </app-error-messages>
              </div>
            </div>
          </form>
        </div>
        <div class="ui-g-12 text-center">
          <app-loading *ngIf="isPosting()" type="SMALL_LOADER"></app-loading>
        </div>
        <div class="ui-g-12">
          <app-error-messages *ngIf="this.editData.password_edit.api_result.PromiseResult.success"
            [api_result]="this.editData.password_edit.api_result"></app-error-messages>
          <app-error-messages [api_result]="this.editData.mobile_email_fetch_api_result"></app-error-messages>
        </div>
      </div>
    </p-fieldset>
  </div>
  <div class="ui-g-12">
    <p-fieldset [style]="{ border: '1px solid #000000' }">
      <p-header><b>Members Data Update</b></p-header>
      <div class="ui-g">
        <div class="ui-g-12">
          <p-fieldset [style]="{ border: '1px solid #000000' }">
            <p-header><b>Select a Member</b></p-header>
            <div class="ui-g-12 ui-lg-2">
              <label for="chooseMember">Choose Member:</label>
            </div>
            <div class="ui-g-12 ui-lg-8">
              <p-dropdown class="notranslate" id="chooseMember" name="chooseMember" [options]="this.editData.patientEdit_Data.members.data"
                [(ngModel)]="
                  this.editData.patientEdit_Data.patientFetchedCurrentData
                " (onChange)="this.onMemberChange()" [filter]="true" placeholder="Select" #chooseMember="ngModel"
                required>
              </p-dropdown>
            </div>
          </p-fieldset>
        </div>

        <ng-container *ngIf="this.editData.patientEdit_Data.members.currentGUID != ''">
          <div class="ui-g-12">
            <p-fieldset [style]="{ border: '1px solid #000000' }">
              <p-header><b>Patient Data</b></p-header>
              <div>
                <form accept-charset="UTF-8" #membershipform="ngForm" (submit)="patientAccountSubmission()">
                  <div class="ui-g-12">
                    <div class="card no-margin">
                      <!-- <p-fieldset [style]="{'border':'1px solid #000000'}"> -->
                      <!-- <p-header><b>Personal Information</b></p-header> -->
                      <div class="ui-g">
                        <div class="ui-g form-group">
                          <div class="ui-g-8">
                            <div class="ui-g-12 ui-md-4">
                              <label for="firstname">First Name<span class="req">*</span></label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <input id="firstname" type="text" pInputText
                                [pKeyFilter]="this.editData.reg_exp.name_input" style="
                                  width: 260px;
                                  border-color: rgb(16, 151, 16);
                                  color: black;
                                  opacity: inherit;
                                " [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.first_name
                                " name="firstname" #firstname="ngModel" required />
                              <div *ngIf="
                                  firstname.invalid &&
                                  (firstname.dirty || firstname.touched)
                                " class="alert alert-danger">
                                <div *ngIf="firstname.errors.required" class="invalid">
                                  First name is required.
                                </div>
                                <div *ngIf="firstname.errors.FieldValidator" class="invalid">
                                  Invalid First name.
                                </div>
                              </div>
                            </div>

                            <div class="ui-g-12 ui-md-4">
                              <label for="middlename">Middle Name</label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <input id="middlename" type="text" pInputText
                                [pKeyFilter]="this.editData.reg_exp.name_input" style="
                                  width: 260px;
                                  color: black;
                                  opacity: inherit;
                                " [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.middle_name
                                " #middlename="ngModel" name="middlename" />
                              <div *ngIf="
                                  middlename.invalid &&
                                  (middlename.dirty || middlename.touched)
                                " class="alert alert-danger">
                                <div *ngIf="middlename.errors.FieldValidator" class="invalid">
                                  Invalid Middle name.
                                </div>
                              </div>
                            </div>

                            <div class="ui-g-12 ui-md-4">
                              <label for="lastname">Last Name<span class="req">*</span></label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <input id="lastname" type="text" pInputText
                                [pKeyFilter]="this.editData.reg_exp.name_input" style="
                                  width: 260px;
                                  border-color: rgb(16, 151, 16);
                                  color: black;
                                  opacity: inherit;
                                " [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.last_name
                                " name="lastname" #lastname="ngModel" required />
                              <div *ngIf="
                                  lastname.invalid &&
                                  (lastname.dirty || lastname.touched)
                                " class="alert alert-danger">
                                <div *ngIf="lastname.errors.required" class="invalid">
                                  Last name is required.
                                </div>
                                <div *ngIf="lastname.errors.FieldValidator" class="invalid">
                                  Invalid Last name.
                                </div>
                              </div>
                            </div>

                            <div class="ui-g-12">
                              <label for="gender">Gender<span class="req">*</span></label>
                            </div>
                            <div class="ui-g-12">
                              <div class="ui-g">
                                <div class="ui-g-12 ui-md-4 ui-sm-12">
                                  <p-radioButton name="gender" value="male" label="Male" [(ngModel)]="
                                      this.editData.patientEdit_Data
                                        .patientEditForm_Data.gender
                                    " name="gender" #gender="ngModel" required></p-radioButton>
                                </div>
                                <div class="ui-g-12 ui-md-4 ui-sm-12">
                                  <p-radioButton name="gender" value="female" label="Female" [(ngModel)]="
                                      this.editData.patientEdit_Data
                                        .patientEditForm_Data.gender
                                    " name="gender" #gender="ngModel" required>
                                  </p-radioButton>
                                  <!-- required></p-radioButton> -->
                                </div>
                                <div class="ui-g-12 ui-md-4 ui-sm-12">
                                  <p-radioButton name="gender" value="other" label="Other" [(ngModel)]="
                                      this.editData.patientEdit_Data
                                        .patientEditForm_Data.gender
                                    " name="gender" #gender="ngModel" required>
                                  </p-radioButton>
                                  <!-- required></p-radioButton> -->
                                </div>

                                <div *ngIf="
                                    gender.invalid &&
                                    (gender.dirty || gender.touched)
                                  " class="alert alert-danger">
                                  <div *ngIf="gender.errors.required" class="invalid">
                                    Gender is required.
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="ui-g-12 ui-md-4">
                              <label for="zip_code">Zip Code</label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <input id="zip_code" type="text" pInputText [pKeyFilter]="this.editData.reg_exp.zipCode"
                                style="
                                  width: 260px;
                                  border-color: rgb(16, 151, 16);
                                " [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.zip_code
                                " name="zip_code" #zip_code="ngModel" />
                              <!-- required /> -->
                              <!-- <div *ngIf="zip_code.invalid && (zip_code.dirty || zip_code.touched)"
                                                                class="alert alert-danger">
                                                                <div *ngIf="zip_code.errors.required" class="invalid">
                                                                    Zip Code is required.
                                                                </div>
                                                            </div> -->
                            </div>
                            <div class="ui-g-12 ui-md-4">
                              <label for="city">City</label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <input id="city" type="text" pInputText [pKeyFilter]="this.editData.reg_exp.city_input"
                                style="
                                  width: 260px;
                                  border-color: rgb(16, 151, 16);
                                " [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.city
                                " name="city" #city="ngModel" />
                              <!-- required /> -->
                              <!-- <div *ngIf="city.invalid && (city.dirty || city.touched)"
                                                                class="alert alert-danger">
                                                                <div *ngIf="city.errors.required" class="invalid">
                                                                    City is required.
                                                                </div>
                                                            </div> -->
                            </div>
                            <div class="ui-g-12 ui-md-4">
                              <label for="add1">Address 1</label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <input id="add1" type="text" pInputText [pKeyFilter]="this.editData.reg_exp.address"
                                style="
                                  width: 260px;
                                  border-color: rgb(16, 151, 16);
                                " [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.address_line_1
                                " name="address_line_1" #address_line_1="ngModel" />
                              <!-- required /> -->
                              <!-- <div *ngIf="address_line_1.invalid && (address_line_1.dirty || address_line_1.touched)"
                                                                class="alert alert-danger">
                                                                <div *ngIf="address_line_1.errors.required" class="invalid">
                                                                    Address is required.
                                                                </div>
                                                            </div> -->
                            </div>
                            <div class="ui-g-12 ui-md-4">
                              <label for="add2">Address 2<span class="req"></span></label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <input id="add2" type="text" pInputText style="width: 260px"
                                [pKeyFilter]="this.editData.reg_exp.address" [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.address_line_2
                                " name="address_line_2" #address_line_2="ngModel" />
                            </div>

                            <div class="ui-g-12">
                              <div class="ui-g-12">
                                <label for="primarycontact">Primary No.<span class="req">*</span></label>
                              </div>

                              <div class="ui-g-4 ui-md-2">
                                <input id="primarycontact" type="text" pInputText style="
                                    width: 55px;
                                    border-color: rgb(16, 151, 16);
                                    color: black;
                                    opacity: inherit;
                                  " name="selected_primary" #selected_primary="ngModel" [(ngModel)]="
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data.phone_code
                                  " disabled class="form-check-input" />
                              </div>
                              <div class="ui-g-8">
                                <input id="primaryphone" type="text" pInputText [pKeyFilter]="
                                    this.editData.reg_exp.phoneNumber
                                  " maxlength="20" style="
                                    width: 155px;
                                    border-color: rgb(16, 151, 16);
                                  " [(ngModel)]="
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data
                                      .primary_contact_ten_digits
                                  " name="primaryno" #primaryno="ngModel" required class="form-check-input" />

                                <div *ngIf="
                                    primaryno.invalid &&
                                    (primaryno.dirty || primaryno.touched)
                                  ">
                                  <div *ngIf="primaryno.errors.required" class="invalid">
                                    Primary Phone is required.
                                  </div>
                                </div>
                                <!-- <div *ngIf="(primaryno.dirty || primaryno.touched)">
                                                                    <div class="invalid"
                                                                        *ngIf="this.editData.patientEdit_Data.patientEditForm_Data.primary_contact_ten_digits?.length!=10">
                                                                        Phone number should be of 10 digits
                                                                    </div>
                                                                </div> -->
                              </div>
                            </div>

                            <div class="ui-g-12">
                              <div class="ui-g-12">
                                <label for="secondarycontact">Secondary No.
                                </label>
                              </div>

                              <div class="ui-g-4 ui-md-2">
                                <input id="secondarycontact" type="text" pInputText style="
                                    width: 55px;
                                    border-color: rgb(16, 151, 16);
                                    color: black;
                                    opacity: inherit;
                                  " name="selected_primary" #selected_primary="ngModel" [(ngModel)]="
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data.phone_code
                                  " disabled class="form-check-input" />
                              </div>
                              <div class="ui-g-8">
                                <input id="secondaryphone" type="text" pInputText [pKeyFilter]="
                                    this.editData.reg_exp.phoneNumber
                                  " maxlength="20" style="
                                    width: 155px;
                                    border-color: rgb(16, 151, 16);
                                  " [(ngModel)]="
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data
                                      .secondary_contact_ten_digits
                                  " name="secondaryno" #secondaryno="ngModel" class="form-check-input" />
                                <!-- <div
                                                                    *ngIf="(secondaryno.invalid && (secondaryno.dirty || secondaryno.touched))">
                                                                    <div *ngIf="secondaryno.errors.required"
                                                                        class="invalid">
                                                                        Primary Phone is required.
                                                                    </div>
                                                                </div> -->
                                <!-- <div
                                                                    *ngIf="(secondaryno.dirty || secondaryno.touched) && this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_ten_digits?.length>0">
                                                                    <div class="invalid"
                                                                        *ngIf="this.editData.patientEdit_Data.patientEditForm_Data.secondary_contact_ten_digits?.length!=10">
                                                                        Phone number should be of 10 digits
                                                                    </div>
                                                                </div> -->
                              </div>
                            </div>
                          </div>

                          <div class="ui-g-12">
                            <div class="ui-g-12 ui-md-4">
                              <label for="dob">Date Of Birth<span class="req">*</span></label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <p-calendar id="dob" class="notranslate" [maxDate]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.max_date
                                " dateFormat="dd/mm/yy" [monthNavigator]="true" [yearNavigator]="true"
                                yearRange="1900:2025" [showIcon]="true" placeholder="dd/mm/yyyy"
                                #date_of_birth="ngModel" name="date_of_birth" [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.date_of_birth_date
                                " [showButtonBar]="true" [todayButtonStyleClass]="'hideTodayButton'" required>
                              </p-calendar>
                              <div *ngIf="
                                  date_of_birth.invalid &&
                                  (date_of_birth.dirty || date_of_birth.touched)
                                " class="alert alert-danger">
                                <div *ngIf="date_of_birth.errors.required">
                                  Date of Birth is required.
                                </div>
                              </div>
                            </div>

                            <div class="ui-g-12 ui-md-4">
                              <label for="state">State<span class="req">*</span></label>
                            </div>
                            <div class="ui-g-12 ui-md-8">
                              <p-dropdown id="state" [options]="
                                  this.editData.patientEdit_Data.other_data
                                    .states
                                " [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.selectedState
                                " placeholder="Select State" name="state" #state="ngModel" required>
                              </p-dropdown>
                            </div>

                            <div class="ui-g-12 ui-md-4">
                              <label for="unid">Unique Identification
                                <!-- <span class="req">*</span> -->
                              </label>
                            </div>

                            <div class="ui-g-12 ui-md-8">
                              <p-dropdown id="unid" [options]="
                                  this.editData.patientEdit_Data.other_data
                                    .unique_id
                                " [(ngModel)]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.identification_type
                                " placeholder="Select" [style]="{ width: '260px' }" name="unique_id_name"
                                #unique_id_name="ngModel" [showClear]="true"></p-dropdown>
                              <div *ngIf="
                                  unique_id_name.invalid &&
                                  (unique_id_name.dirty ||
                                    unique_id_name.touched)
                                " class="alert alert-danger">
                                <div *ngIf="unique_id_name.errors.required" class="invalid">
                                  Unique Identification is required
                                </div>
                              </div>
                            </div>

                            <div class="ui-g-12 ui-md-12" *ngIf="
                                !(
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.identification_url ==
                                    null ||
                                  (this.editData.patientEdit_Data
                                    .patientEditForm_Data.identification_url !=
                                    null &&
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data.identification_url
                                      .length == 0)
                                )
                              ">
                              <div class="ui-g-12" style="display: table">
                                <div class="text text-center" style="display: table-cell">
                                  <img style="
                                      height: 200px;
                                      object-fit: scale-down;
                                    " [src]="
                                      this.editData.patientEdit_Data
                                        .patientEditForm_Data
                                        .identification_url == null ||
                                      (this.editData.patientEdit_Data
                                        .patientEditForm_Data
                                        .identification_url != null &&
                                        this.editData.patientEdit_Data
                                          .patientEditForm_Data
                                          .identification_url.length == 0)
                                        ? ''
                                        : this.editData.patientEdit_Data
                                            .patientEditForm_Data
                                            .identification_url
                                    " />
                                </div>
                              </div>
                            </div>

                            <div class="ui-g-12">
                              <p-fileUpload name="unique_id_file" [chooseLabel]="
                                  this.editData.patientEdit_Data
                                    .patientEditForm_Data.identification_url
                                    ?.length != 0
                                    ? 'Change Identification Document'
                                    : 'Upload Identification Document'
                                " [showCancelButton]="false" chooseIcon="pi pi-upload" [disabled]="
                                  !this.editData.patientEdit_Data
                                    .patientEditForm_Data.identification_type
                                " (onSelect)="
                                  this.editData.fileSave(
                                    this.editData.util_data.fileType.unique_id,
                                    $event.files[0],
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data,
                                    'identification'
                                  )
                                " (onRemove)="
                                  this.editData.removeFile(
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data,
                                    'identification'
                                  )
                                " [showUploadButton]="false" [maxFileSize]="
                                  this.editData.util_data.fileSize.unique_id
                                " multiple="false" styleClass="p-fileUpload-label-fix" [fileLimit]="1"
                                accept="image/*">
                              </p-fileUpload>

                              <span>
                                <p>
                                  <b>Note:</b>ID Document upload is enabled only
                                  upon selecting the ID type.
                                </p>
                              </span>
                            </div>

                            <div class="ui-g-12 ui-md-4">
                              <label for="zip">Photo</label>
                            </div>
                            <div class="ui-g-12 ui-md-8"></div>
                            <div class="ui-g-12 ui-md-12" style="
                                display: table;
                                height: 200px;
                                overflow: hidden;
                              ">
                              <div style="
                                  display: table-cell;
                                  vertical-align: middle;
                                  text-align: center;
                                ">
                                <img [src]="
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data.avatar_url ==
                                      null ||
                                    (this.editData.patientEdit_Data
                                      .patientEditForm_Data.avatar_url !=
                                      null &&
                                      this.editData.patientEdit_Data
                                        .patientEditForm_Data.avatar_url
                                        .length == 0)
                                      ? './assets/images/test_profile.png'
                                      : this.editData.patientEdit_Data
                                          .patientEditForm_Data.avatar_url
                                  " style="
                                    border-radius: 50%;
                                    margin-right: auto;
                                    margin-left: auto;
                                  " class="avatar-image" />
                              </div>
                            </div>

                            <div class="ui-g-12">
                              <!-- <div style="margin:3px;">
                                                        <p-confirmDialog key="confirm-delete-document"
                                                            header="Delete Profile Pic" acceptLabel="Yes"
                                                            rejectLabel="No" [(visible)]="confirmDialogVisible">
                                                        </p-confirmDialog>
                                                    </div> -->
                              <div>
                                <p-fileUpload name="demo[]" [chooseLabel]="
                                    this.editData.patientEdit_Data
                                      .patientEditForm_Data.avatar_url
                                      ?.length != 0
                                      ? 'Change Profile Photo'
                                      : 'Upload Profile Photo'
                                  " chooseIcon="pi pi-upload" (onSelect)="
                                    this.editData.fileSave(
                                      this.editData.util_data.fileType.photo,
                                      $event.files[0],
                                      this.editData.patientEdit_Data
                                        .patientEditForm_Data,
                                      'file'
                                    )
                                  " (onRemove)="
                                    this.editData.removeFile(
                                      this.editData.patientEdit_Data
                                        .patientEditForm_Data,
                                      'file'
                                    )
                                  " styleClass="p-fileUpload-label-fix" [showUploadButton]="false" [maxFileSize]="
                                    this.editData.util_data.fileSize.photo
                                  " multiple="false" [showCancelButton]="false" [fileLimit]="1" accept="image/*">
                                </p-fileUpload>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- </p-fieldset> -->
                    </div>
                  </div>
                  <div class="alert alert-danger" role="alert">
                    <p class="text-center text-gray-underline">
                      <span class="font-weight-bold">Note</span>: The file type
                      supported for Unique Identification and Photo are
                      JPEG,JPG,PNG.
                    </p>
                  </div>
                  <p-footer>
                    <div class="ui-g-12" style="text-align-last: right">
                      <button pButton type="submit" label="Save" style="margin-bottom: 10px; margin-right: 5px"
                        [disabled]="!membershipform.valid || isPosting()"></button>
                    </div>
                    <div class="ui-g-12 text-center">
                      <app-loading *ngIf="isPosting()" type="SMALL_LOADER"></app-loading>
                    </div>
                    <div class="ui-g-12">
                      <app-error-messages [api_result]="
                          this.editData.patientEdit_Data
                            .patient_update_api_result
                        ">
                      </app-error-messages>
                    </div>
                  </p-footer>
                </form>
              </div>
            </p-fieldset>
          </div>
        </ng-container>
      </div>
    </p-fieldset>
  </div>
</div>